import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService, User } from '@basis/angular-components';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { PadraoService } from '../service/padrao.service';
import { ObservableLotacao, ObservableVariable } from '../util/observable-util';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  [x: string]: any;
  code: any;
  token: string;
  returnIsValid = false;
  authService: AuthService<User>;
  sistemas: Array<any> = [];
  model: any;
  constructor(
    private router: Router,
    private observableVariable: ObservableVariable,
    private lotacaoService: ObservableLotacao,
    private service: PadraoService,
    auth: AuthService<User>) {
    this.code = window.location.search.substring(1).split('=')[1];
    this.token = localStorage.getItem('token');
    this.authService = auth
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.token == null && this.code == null) {
      window.location.href = `${environment.apiEndpoint}/api/Autenticar/login`;
    } else if (this.token !== null && localStorage.getItem('tokenSimulado') == null) {
      return this.verificarPermissoes(state);
    } else if (this.code !== null) {
      return this.obterToken(this.code);
    }
  }

  canActivateChild = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => this.canActivate(route, state);

  verificarPermissoes(state: RouterStateSnapshot) {
    return this.lotacaoService.getLotacao.map(permissoes => {
      return true;
    });
  }

  obterToken(code: any) {
    return this.service.ObterToken(code).map(token => {
      localStorage.setItem('token', token.access_Token);
      this.code = null;
      window.location.href = `${window.location.origin}/#/sistema/modulos`;
      //window.location.reload();
      return true;
    })
  }

  validationAccessPerHour(url: any) {
    const actionRegex = /\/?(?:.*)\/(.*)\/(editar|cadastrar|enviar-cadastro|alterar-responsavel)(?:.*)$/;
    const routeInfo = actionRegex.exec(url);
    const dataAtual = new Date;
    const dataLimite = new Date(dataAtual.getFullYear() + '-01-31T23:59:59');

    if (dataAtual > dataLimite && routeInfo && String(routeInfo).includes('prestacao-conta')) {
      this.observableVariable.setVariable(true);
      this.router.navigate(['prestacao/prestacao-conta/']);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/autenticacao/auth.guard.ts